var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "overflow-x": "auto" } }, [
    _c("table", { staticClass: "table" }, [
      _c("thead", { staticClass: "text-ascpercase" }, [
        _c(
          "tr",
          [
            !_vm.disableSelection
              ? _c("th", [
                  _c("input", {
                    ref: "isAllRowsSelected",
                    attrs: { type: "checkbox", disabled: !_vm.rows.length },
                    domProps: {
                      checked:
                        _vm.rows.length &&
                        _vm.selectedRows.length === _vm.allRowKeys.length,
                    },
                    on: { click: _vm.selectAllRows },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.tableHeaders, function (header) {
              return _c(
                "th",
                {
                  key: header.key,
                  style: { width: _vm.columnPercentageWidth + "%" },
                  attrs: { scope: "col" },
                },
                [
                  _c("div", { staticStyle: { display: "flex", gap: "5px" } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(header.label) +
                        "\n              "
                    ),
                    _vm.isVisibleOrderByColumn
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  "line-height": "1em",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.orderFilter = {
                                      key: header.key,
                                      type: _vm.filterTypes.asc,
                                    }
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.orderFilter.type ===
                                      _vm.filterTypes.asc &&
                                      _vm.orderFilter.key === header.key
                                      ? "▲"
                                      : "△"
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  "line-height": "1em",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.orderFilter = {
                                      key: header.key,
                                      type: _vm.filterTypes.desc,
                                    }
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.orderFilter.type ===
                                      _vm.filterTypes.desc &&
                                      _vm.orderFilter.key === header.key
                                      ? "▼"
                                      : "▽"
                                  )
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            !_vm.disableActions
              ? _c(
                  "th",
                  { staticClass: "text-center", attrs: { scope: "col" } },
                  [_vm._v("Opciones")]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm.isLoadingData
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "text-center",
                    attrs: { colspan: _vm.tableHeaders.length + 1 },
                  },
                  [_vm._v("Cargando...")]
                ),
              ])
            : _vm._l(_vm.rows, function (row) {
                return _c(
                  "tr",
                  [
                    !_vm.disableSelection
                      ? _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.selectedRows.includes(
                                row[_vm.rowKey]
                              ),
                              value: row[_vm.rowKey],
                            },
                            on: { click: _vm.handleCheckboxClick },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.tableHeaders, function (header) {
                      return _c(
                        "td",
                        { key: header.key },
                        [_vm._t("column-" + header.key, null, { row: row })],
                        2
                      )
                    }),
                    _vm._v(" "),
                    !_vm.disableActions
                      ? _c(
                          "td",
                          { staticClass: "text-center" },
                          [_vm._t("actions", null, { row: row })],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }